module.exports = __webpack_public_path__ + "img/LogonandUserSession.8e7df498.png";